var ModuleMap = {};
ModuleMap["AccountCreation"] = "Account Creation";
ModuleMap["SocialNetwork"] = "Web 2.0 Blogs";
ModuleMap["Bookmarking"] = "Bookmarking";
ModuleMap["Wiki"] = "Wiki";
ModuleMap["WebProfile"] = "Web 2.0 Profile";
ModuleMap["ArticleDirectory"] = "Article Directory";
ModuleMap["ForumProfile"] = "Forum Profile";
ModuleMap["PressRelease"] = "Press Release";
ModuleMap["GooglePlace"] = "Google Place";
ModuleMap["PDF"] = "PDF";
ModuleMap["MoneySite"] = "Money Site";
ModuleMap["Private"] = "Private Blog";
ModuleMap["PrivatePDF"] = "Private PDF";
ModuleMap["PrivateAD"] = "Private Article Directory";
ModuleMap["PrivateBookmark"] = "Private Bookmark";
ModuleMap["Indexer"] = "Indexer";

var ModuleValue = {};

ModuleValue["AccountCreation"] = 0;
ModuleValue["SocialNetwork"] = 1;
ModuleValue["Bookmarking"] = 2;
ModuleValue["WebProfile"] = 3;
ModuleValue["Wiki"] = 4;
ModuleValue["ArticleDirectory"] = 5;
ModuleValue["ForumProfile"] = 6;
ModuleValue["PressRelease"] = 7;
ModuleValue["GooglePlace"] = 8;
ModuleValue["PDF"] = 9;
ModuleValue["MoneySite"] = 10;
ModuleValue["Private"] = 11;
ModuleValue["PrivatePDF"] = 12;
ModuleValue["PrivateAD"] = 13;
ModuleValue["PrivateBookmark"] = 14;
ModuleValue["Indexer"] = 15;

// ModuleValue["Account Creation"] = 0;
// ModuleValue["Web 2.0 Blogs"] = 1;
// ModuleValue["Bookmarking"] = 2;
// ModuleValue["Web 2.0 Profile"] = 3;
// ModuleValue["Wiki"] = 4;
// ModuleValue["Article Directory"] = 5;
// ModuleValue["Forum Profile"] = 6;
// ModuleValue["Press Release"] = 7;
// ModuleValue["Google Place"] = 8;
// ModuleValue["PDF"] = 9;
// ModuleValue["MoneySite"] = 10;
// ModuleValue["Private Blog"] = 11;
// ModuleValue["Private PDF"] = 12;
// ModuleValue["Private Article Directory"] = 13;
// ModuleValue["Private Bookmark"] = 14;
// ModuleValue["Indexer"] = 15;


var PlatformValue = {};

PlatformValue["Premium"] = 1;
PlatformValue["Other"] = 0;


export { ModuleMap, ModuleValue, PlatformValue };